var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWavyEqual(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 128 128",
    style: {
      enableBackground: "new 0 0 128 128"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "_x32_5"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#059D39"
    },
    d: "M0,33.923c6.461-5.697,12.026-9.563,16.69-11.598c4.664-2.03,10.147-3.052,16.445-3.052 c7.933,0,18.632,3.034,32.089,9.097c13.462,6.059,23.092,9.093,28.902,9.093c7.937,0,15.671-2.645,23.197-7.935 c4.501-3.093,8.06-6.348,10.677-9.766v23.439c-3.274,3.011-7.118,5.697-11.537,8.057c-7.362,3.907-14.684,5.86-21.965,5.86 c-2.047,0-4.727-0.244-8.042-0.732c-3.31-0.488-6.316-1.221-9.02-2.197c-1.553-0.488-7.974-3.174-19.266-8.057 c-5.565-2.442-9.776-4.151-12.642-5.127c-4.501-1.384-8.752-2.075-12.76-2.075c-7.118,0-13.543,1.831-19.271,5.494 C9.98,46.7,5.483,50.729,0,56.507V33.923z M0,85.44c6.461-5.697,12.026-9.563,16.69-11.598c4.664-2.03,10.147-3.052,16.445-3.052 c7.933,0,18.632,3.034,32.089,9.097c13.462,6.059,23.092,9.093,28.902,9.093c7.362,0,13.928-1.849,19.696-5.557 c5.769-3.699,10.496-7.75,14.177-12.145v23.439c-5.483,4.476-10.926,7.917-16.323,10.318c-5.402,2.396-11.125,3.599-17.179,3.599 c-2.54,0-5.384-0.307-8.531-0.913c-3.151-0.615-5.995-1.284-8.531-2.017c-1.884-0.651-8.304-3.337-19.266-8.057 c-5.565-2.442-9.776-4.151-12.642-5.127c-4.501-1.384-8.752-2.075-12.76-2.075c-7.204,0-13.747,1.913-19.638,5.738 c-3.6,2.279-7.978,6.226-13.131,11.842V85.44z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavyEqual);
export default __webpack_public_path__ + "static/media/wavy-equal.44ee62fec4483e093a82925831cd97a6.svg";
export { ForwardRef as ReactComponent };